import { PrincipalLayouts } from "../../layouts";
import Editor from "../components/generals/Editor";

export const LandingEdit = () => {
  return (
    <PrincipalLayouts>
      <Editor />
    </PrincipalLayouts>
  );
};
